import { __spreadArray } from "tslib";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import readableFileSize from 'filesize';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import AddImage from '@wix/da-ds/pkg/Icons/24x24/AddImage';
import CollapsibleDetailsBlock from '../CollapsibleDetailsBlock';
import DasInfo from '../../Default/DasInfo';
import { deviationHasFileSizeMetadata } from '../../Default/helpers';
var ImageDetailsBlock = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var t = useTranslation().t;
    var hasDas = useFlag('digital_assets');
    var extendedDeviation = useMemo(function () { return deviation === null || deviation === void 0 ? void 0 : deviation.extended; }, [deviation]);
    var hasSizeData = deviationHasFileSizeMetadata(deviation);
    var imageSizeItem = useMemo(function () {
        if (!hasSizeData) {
            return [];
        }
        var _a = extendedDeviation.originalFile, filesize = _a.filesize, width = _a.width, height = _a.height;
        return [
            {
                label: t('deviation.details.itemsize'),
                value: "".concat(width, "x").concat(height, "px ").concat(readableFileSize(filesize)),
            },
        ];
    }, [extendedDeviation, hasSizeData, t]);
    var detailsItems = useMemo(function () {
        var _a;
        if (!extendedDeviation) {
            return [];
        }
        var exif = (_a = extendedDeviation.exif) !== null && _a !== void 0 ? _a : [];
        var exifItems = exif.map(function (_a) {
            var tag = _a.tag, value = _a.value;
            // there are a metric ton of exif keys, so for sake of
            // sanity anything untranslated should just show the raw key name
            var translatedKey = t("deviation.details.".concat(tag.replace(' ', '')), {
                defaultValue: tag,
            });
            return {
                label: translatedKey,
                value: value,
            };
        });
        return __spreadArray(__spreadArray([], imageSizeItem, true), exifItems, true);
    }, [extendedDeviation, imageSizeItem, t]);
    if (detailsItems.length < 1) {
        if (hasDas && deviation.digitalAsset) {
            return React.createElement(DasInfo, { deviation: deviation });
        }
        return null;
    }
    return (React.createElement("div", { className: className },
        hasDas && deviation.digitalAsset && React.createElement(DasInfo, { deviation: deviation }),
        React.createElement(CollapsibleDetailsBlock, { deviationId: deviation.deviationId, icon: React.createElement(AddImage, null), title: t('deviation.details.title'), items: detailsItems })));
};
ImageDetailsBlock.displayName = 'ImageDetailsBlock';
export default ImageDetailsBlock;
//# sourceMappingURL=ImageDetailsBlock.js.map